import { completeRequest, beginRequest } from "@store/utils";
import type { ManagerSelfServiceState } from "./types";

const finishRequest = completeRequest(["requestsInProgress"]);
const startRequest = beginRequest(["requestsInProgress"]);

export const onGetManagerSelfServiceSettings = (state: ManagerSelfServiceState) => () =>
  startRequest(state);

export const onGetManagerSelfServiceSettingsSuccess = (state: ManagerSelfServiceState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  settings: payload,
});

export const onGetManagerSelfServiceSettingsError = (state: ManagerSelfServiceState) => () =>
  finishRequest(state);

export const onUpdateManagerSelfServiceSettings = (state: ManagerSelfServiceState) => () =>
  startRequest(state);

export const onUpdateManagerSelfServiceSettingsSuccess = (state: ManagerSelfServiceState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  settings: payload,
});

export const onUpdateManagerSelfServiceSettingsError = (state: ManagerSelfServiceState) => () =>
  finishRequest(state);
